import connected from 'app/common/utils/connected';
import { getPermission, type PermissionsSlice } from 'app/permissions/selectors';
import { getResourceString } from 'app/permissions/util';
import { getProjectAdmins } from 'app/project/actions';
import { getProjectState, selectProjectAdmins } from 'app/project/selectors';
import type { ProjectSlice } from 'app/project/types';
import DelinquencyBanner, { type DelinquencyBannerProps } from './delinquency-banner.js';

function mapStateToProps(state: ProjectSlice & PermissionsSlice): Partial<DelinquencyBannerProps> {
  const project = getProjectState(state).get('data');
  const billingStatus = project?.getIn(['status', 'billing', 'subscriptionStatus'], 'active');
  return {
    billingStatus,
    hasBillingPermissions: getPermission(state, {
      action: 'project-billing:update',
      resource: getResourceString('project-billing')
    }),
    admins: selectProjectAdmins(state)
  };
}

const mapDispatchToProps = {
  getProjectAdmins
};

export function onComponentWillMount(props: DelinquencyBannerProps): void {
  if (!props.hasBillingPermissions && props.billingStatus === 'past_due') {
    props.getProjectAdmins();
  }
}

export default connected<DelinquencyBannerProps>({
  loading: false,
  mapStateToProps,
  mapDispatchToProps,
  onComponentWillMount
})(DelinquencyBanner);
